import { render, staticRenderFns } from "./PublisherList.vue?vue&type=template&id=684072dc&scoped=true&lang=pug&"
import script from "./PublisherList.vue?vue&type=script&lang=js&"
export * from "./PublisherList.vue?vue&type=script&lang=js&"
import style0 from "./PublisherList.vue?vue&type=style&index=0&id=684072dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684072dc",
  null
  
)

export default component.exports